export function useProducts() {
  const { getProducts } = useBackendService();
  const commerceStore = useCommerceStore();
  const products = useState("products", () => null);

  const fetchProducts = async () => {
    if (products.value) return products.value;

    const result = await getProducts();
    if (result) {
      products.value = result;
      commerceStore.updateProducts(result);
    }
    return result;
  };

  return {
    products,
    fetchProducts,
  };
}
